import React from "react";
import "./styles.scss";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow.svg";

import useInitialConfigStore from "../../storeModules/useInitialConfigStore";

const CustomPrevArrow = (props) => {
  const { buttons } = useInitialConfigStore.getState((state) => state).theme;

  const { className, onClick } = props;

  return (
    <div
      className={`${className} custom-prev-arrow-services`}
      onClick={onClick}
      style={{
        backgroundColor: buttons.backgroundColor,
      }}
    >
      <ArrowIcon fill={buttons.color ? buttons.color : "#ffffff"} />
    </div>
  );
};

const CustomNextArrow = (props) => {
  const { buttons } = useInitialConfigStore.getState((state) => state).theme;

  const { className, onClick } = props;

  return (
    <div
      className={`${className} custom-next-arrow-services`}
      onClick={onClick}
      style={{
        backgroundColor: buttons.backgroundColor,
      }}
    >
      <ArrowIcon fill={buttons.color ? buttons.color : "#ffffff"} />
    </div>
  );
};

export { CustomPrevArrow, CustomNextArrow };
